import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "h1" }, "Request Access", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, "You can request access to a production or organization by entering its StageCode below.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_group = _resolveComponent("input-group")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ModalBase = _resolveComponent("ModalBase")!

  return (_openBlock(), _createBlock(_component_ModalBase, {
    title: "Request Access",
    size: "modal-md",
    ref: "modal",
    "is-loading": _ctx.isLoading,
    "loading-text": "Please Wait",
    "has-header": false,
    "has-toolbar": true
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createVNode(_component_input_group, {
          label: "StageCode",
          "is-required": true
        }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("input", {
              class: _normalizeClass(["form-control", {'is-invalid': _ctx.v$.requestCommand.StageCode.$error}]),
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.requestCommand.StageCode) = $event))
            }, null, 2), [
              [_vModelText, _ctx.requestCommand.StageCode]
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Button, {
          onClick: _ctx.requestAccess,
          type: "primary",
          "is-loading": _ctx.isLoading
        }, {
          default: _withCtx(() => [
            _createTextVNode("Request Access")
          ]),
          _: 1
        }, 8, ["onClick", "is-loading"]),
        _createVNode(_component_Button, {
          onClick: _ctx.toggleModal,
          type: "secondary",
          class: "d-md-none mt-4"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Cancel")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["is-loading"]))
}